export enum PermissionsEnums {
  /* Auth Permissions */
  LOGIN = "login",

  /* User Permissions */
  CREATE_USER = "create_user",
  UPDATE_USER = "update_user",
  DELETE_USER = "delete_user",
  VIEW_USER = "view_user",
  UNLOCK_USER = "unlock_user",

  /* Role Permissions */
  CREATE_ROLE = "create_role",
  UPDATE_ROLE = "update_role",
  DELETE_ROLE = "delete_role",
  VIEW_ROLE = "view_role",
  ROLES_LIST = "roles_list",

  /* Permissions */
  VIEW_PERMISSION = "view_permission",

  /* Location Permissions */
  CREATE_LOCATION = "create_location",
  UPDATE_LOCATION = "update_location",
  VIEW_LOCATION = "view_location",
  HAS_ACCESS_ON_ALL_LOCATIONS = "has_access_on_all_locations",
  LOCATIONS_LIST = "locations_list",

  /* Floor Permissions */
  CREATE_FLOOR = "create_floor",
  UPDATE_FLOOR = "update_floor",
  DELETE_FLOOR = "delete_floor",
  VIEW_FLOOR = "view_floor",

  /* Room Permissions */
  CREATE_ROOM = "create_room",
  UPDATE_ROOM = "update_room",
  DELETE_ROOM = "delete_room",
  VIEW_ROOM = "view_room",

  /* Bed Permissions */
  CREATE_BED = "create_bed",
  UPDATE_BED = "update_bed",
  DELETE_BED = "delete_bed",
  VIEW_BED = "view_bed",

  /* Access Control */
  UNRESTRICTED_ACCESS = "unrestricted_access",

  /* IP Whitelist */
  CREATE_IP_WHITELIST = "create_ip_whitelist",
  UPDATE_IP_WHITELIST = "update_ip_whitelist",
  DELETE_IP_WHITELIST = "delete_ip_whitelist",
  VIEW_IP_WHITELIST = "view_ip_whitelist",

  /* Country Access */
  CREATE_COUNTRY_ACCESS = "create_country_access",
  UPDATE_COUNTRY_ACCESS = "update_country_access",
  DELETE_COUNTRY_ACCESS = "delete_country_access",
  VIEW_COUNTRY_ACCESS = "view_country_access",

  /* Residents */
  CREATE_RESIDENT = "create_resident",
  UPDATE_RESIDENT = "update_resident",
  DELETE_RESIDENT = "delete_resident",
  VIEW_RESIDENT = "view_resident",

  /* Bowel Movement Permissions */
  CREATE_BOWEL_MOVEMENT = "create_bowel_movement",
  VIEW_BOWEL_MOVEMENT = "view_bowel_movement",

  /* Medication Log Permissions */
  VIEW_MEDICATION_LOG = "view_medication_log",
  UPDATE_MEDICATION_LOG = "update_medication_log",
  VOID_MEDICATION_LOG = "void_medication_log",

  /* Medication Permissions */
  CREATE_MEDICATION = "create_medication",
  VIEW_MEDICATION = "view_medication",
  UPDATE_MEDICATION = "update_medication",
  SIGN_OFF_MEDICATION = "sign_off_medication",

  /* Fluid Intake Permissions */
  VIEW_FLUID_INTAKE = "view_fluid_intake",
  CREATE_FLUID_INTAKE = "create_fluid_intake",

  /* Fluid Output Permissions */
  VIEW_FLUID_OUTPUT = "view_fluid_output",
  CREATE_FLUID_OUTPUT = "create_fluid_output",

  /* Forms */
  CREATE_FORM = "create_form",
  UPDATE_FORM = "update_form",
  DELETE_FORM = "delete_form",
  VIEW_FORM = "view_form",
  FILL_FORM = "fill_form",
  VIEW_FORM_ENTRIES = "view_form_entries",
  SIGN_OFF_ADMISSION_CHECKLIST_FORM = "sign_off_admission_checklist_form",
  SIGN_OFF_ACCIDENT_INCIDENT_FORM = "sign_off_accident_incident_form",
  VOID_FORM_SUBMISSION = "void_form_submission",

  /*  Tags */
  CREATE_STATUS_FLAG = "create_status_flag",
  UPDATE_STATUS_FLAG = "update_status_flag",
  DELETE_STATUS_FLAG = "delete_status_flag",
  VIEW_STATUS_FLAG = "view_status_flag",

  /* Resident Status Flag */
  VIEW_RESIDENT_STATUS_FLAG = "view_resident_status_flag",

  /* Calendar */
  CREATE_CALENDAR_EVENT = "create_calendar_event",
  UPDATE_CALENDAR_EVENT = "update_calendar_event",
  DELETE_CALENDAR_EVENT = "delete_calendar_event",
  VIEW_CALENDAR_EVENT = "view_calendar_event",
  COMPLETE_CALENDAR_EVENT = "complete_calendar_event",
  CANCEL_CALENDAR_EVENT = "cancel_calendar_event",

  /* Shift Handovers */
  CREATE_SHIFT_HANDOVER = "create_shift_handover",
  UPDATE_SHIFT_HANDOVER = "update_shift_handover",
  VIEW_SHIFT_HANDOVER = "view_shift_handover",
  SIGN_SHIFT_HANDOVER = "sign_shift_handover",

  /* Resident Reports */
  GENERATE_RESIDENT_REPORT = "generate_resident_report",
  VIEW_RESIDENT_REPORT = "view_resident_report",

  /* Body Map Permissions */
  CREATE_BODY_MAP_ENTRY = "create_body_map_entry",
  VIEW_BODY_MAP_ENTRY = "view_body_map_entry",
  UPDATE_BODY_MAP_ENTRY = "update_body_map_entry",

  /* Audit Log */
  VIEW_AUDIT_LOG = "view_audit_log",
  EXPORT_AUDIT_LOG = "export_audit_log",
}
